import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '../layout/DashboardLayout';
import CropList from '../crops/CropList';
import TaskList from '../tasks/TaskList';
import ResourceList from '../resources/ResourceList';
import SalesList from '../sales/SalesList';
import VendorList from '../vendors/VendorList';
import EquipmentList from '../equipment/EquipmentList'; // Add this line
import DashboardOverview from './DashboardOverview';

const Dashboard = () => {
  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<DashboardOverview />} />
        <Route path="/crops" element={<CropList />} />
        <Route path="/tasks" element={<TaskList />} />
        <Route path="/equipment" element={<EquipmentList />} /> {/* Add this line */}
        <Route path="/resources" element={<ResourceList />} />
        <Route path="/sales" element={<SalesList />} />
        <Route path="/vendors" element={<VendorList />} />
      </Routes>
    </DashboardLayout>
  );
};

export default Dashboard;